import globalColors from '@data/variables/global-colors';

(function () {
	Vue.component('nominow-dashboard-tile', {
		props: {
			index: {
				type: Number,
				required: true
			}
		},
		data: function () {
			const parent = this.$parent;
			let visible = false;
			let chart = {};
			if (parent && parent.charts && parent.charts.length > this.index) {
				visible = true;
				chart = parent.charts[this.index];
				if (!chart.TableName) {
					chart.TableName = parent.dashboard.TableName;
				}
			}
			return {
				chart: chart,
				visible: visible,
				activeChart: null,
				id: new Date().getTime()
			};
		},
		template: /*html*/`<div class="tile is-child is-chart-tile" v-if="visible">
	<div class="card chart-card">
		<header class="card-header ">
			<p class="card-header-title ">{{chart.Name}} </p>
			<div :id="'info-tooltip-' + id" class="dropdown is-hoverable is-right" style="margin-top: 0.2rem;" v-if="chart.Description">
				<div class="dropdown-trigger">
					<a :data-toggle-dropdown-id="'info-tooltip-' + id" aria-haspopup="true" aria-controls="dropdown-menu" class="button is-clean js-toggle-dropdown">
						<span class="icon has-text-centered  is-small has-text-light"><i aria-hidden="true" class="fa  fa-info"></i></span>
					</a>
				</div>
				<div id="dropdown-menu" role="menu" class="dropdown-menu is-info">
					<div class="dropdown-content">
						<div class="dropdown-item">
							{{chart.Description}}
						</div>
					</div>
				</div>
			</div>
			<div :id="'chart-dropdown-' + id" class="dropdown is-right card-header-icon">
				<div :data-toggle-dropdown-id="'chart-dropdown-' + id" class="dropdown-trigger js-toggle-dropdown">
					<button type="button" aria-haspopup="true" aria-controls="chart-dropdown-menu" class="button is-menu">
						<span class="icon -small "><i aria-hidden="true" class="ci "><svg viewBox="0 0 32 32" alt="Menu" class="svg"><use xlink:href="/assets/toolkit/svgs/icon-sprite.svg#icon-dashboard-edit"></use></svg></i></span>
					</button>
				</div>
				<div id="chart-dropdown-menu" role="menu" class="dropdown-menu is-menu">
					<div class="dropdown-content" style="">
						<a class="dropdown-item" v-on:click="btnCompareChart('compare')" v-if="chart.TableName == 'DashContactProfileDetail'">Compare chart</a>
						<hr class="dropdown-divider" v-if="chart.TableName == 'DashContactProfileDetail'" />
						<a class="dropdown-item" v-on:click="btnExportChart('print')">Print chart</a>

						<hr class="dropdown-divider" />
						<a class="dropdown-item" v-on:click="btnExportChart('png')">Download PNG image</a>
						<a class="dropdown-item" v-on:click="btnExportChart('jpeg')">Download JPEG image</a>
						<a class="dropdown-item" v-on:click="btnExportChart('pdf')">Download PDF image</a>
						<a class="dropdown-item" v-on:click="btnExportChart('csv')">Download CSV</a>
					</div>
				</div>
			</div>
		</header>
		<div :class="'chart-'+chart.Chart">
			<nominow-dashboard-chart :data.sync="chart" v-on:chartReady="activeChart = $event"></nominow-dashboard-chart>
		</div>
	</div>
</div>`,
		methods: {
			btnExportChart: function (option) {
				//vuelog(this.activeChart.chart);
				if (this.activeChart == null || this.activeChart.chart == null) {
					return;
				}
				/* See documentation https://api.highcharts.com/class-reference/Highcharts.Chart.html#exportChart */
				const chartOptions = {
					chart: {
						backgroundColor: globalColors.primary.hue3
					},
					plotOptions: {
						series: {
							dataLabels: {
								enabled: true
							}
						}
					}
				};
				if (option == 'print') {
					this.activeChart.chart.print();
				} else if (option == 'png') {
					this.activeChart.chart.exportChart({
						type: 'image/png'
					},
						chartOptions
					);
				} else if (option == 'jpeg') {
					this.activeChart.chart.exportChart({
						type: 'image/jpeg'
					},
						chartOptions
					);
				} else if (option == 'pdf') {
					this.activeChart.chart.exportChart({
						type: 'application/pdf'
					},
						chartOptions
					);
				} else if (option == 'svg') {
					this.activeChart.chart.exportChart({
						type: 'image/svg+xml'
					},
						chartOptions
					);
				} else {
					this.activeChart.chart.print();
				}
				if (option == 'print') {
					this.activeChart.chart.print();
				} else if (option == 'png') {
					this.activeChart.chart.exportChart({
						type: 'image/png'
					},
						chartOptions
					);
				} else if (option == 'jpeg') {
					this.activeChart.chart.exportChart({
						type: 'image/jpeg'
					},
						chartOptions
					);
				} else if (option == 'pdf') {
					this.activeChart.chart.exportChart({
						type: 'application/pdf'
					},
						chartOptions
					);
				} else if (option == 'svg') {
					this.activeChart.chart.exportChart({
						type: 'image/svg+xml'
					},
						chartOptions
					);
				} else if (option == 'csv') {
					const csv = this.activeChart.chart.getCSV();
					const base64Csv = btoa(encodeURIComponent(csv).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)));
					window.openb64FileDownload(base64Csv, `${window.nominowClientName}-${this.chart.Name}.csv`, 'text/csv');
				} else {
					this.activeChart.chart.print();
				}
			},
			btnCompareChart: function (option) {
				//first parent is dashboard template second parent is dashboard vue app itself.

				this.$parent.$parent.compareinsightgroupselectedleft = null;
				this.$parent.$parent.compareinsightgroupselectedright = null;
				var chartDefault = window.cloneObject(this.chart);
				chartDefault.filter = null;
				this.$parent.$parent.comparemodal = {
					title: this.chart.Name,
					originalChart: window.cloneObject(chartDefault),
					filterChart: window.cloneObject(chartDefault),
				};
			}
		}
	});
	Vue.component('nominow-dashboard-chart', {
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				error: null,
				chart: null,
				currentchart: null,
				chartRequest: null,
				chartData: null,
				customcomponent: null,
				metric: null,
				log: null,
				extraPlotLines: []
			};
		},
		template: /*html*/`
        <div class="card-content">
            <div v-if="currentchart == null && error == null && table == null && metric == null && customcomponent == null">
                <span class="loader"></span>
            </div>
            <div v-if="currentchart">
				<component :is="'nominow-chart-' + currentchart"
						   :init="data"
						   :chartData="chartData"
						   :chartRequest="chartRequest"
						   v-on:chartReady="chartReady($event)"></component>
			</div>
			<div v-if="metric != null">
				<nominow-metric :amount1="metric.amount1" :amount2="metric.amount2" :amountpct="metric.amountpct"
								:amountpctclass="metric.amountpctclass" :amount1text="metric.amount1text" :amount2text="metric.amount2text"></nominow-metric>
			</div>
			<div v-if="customcomponent != null">
				<component v-bind:is="customcomponent" ref="customChartComponent" :parent="this"></component>
			</div>
			<div v-if="error != null">
				No data to show
				<!--{{error}}-->
			</div>
			<div v-if="data.showLog">
				Data: {{data}}
				<br/><br/>
				ChartData: {{log}}
				<br/><br/>
				Chart: {{chart}}
			</div>
        </div>
        `,
		created: function () {
			const self = this;
			self.error = null;
			self.table = null;
			self.chart = null;
			if (this.data && this.data.IsCustom) {
				vuelog('custom chart created', this.data)
				this.showCustomChart();
			}
			else {
				let dim1 = this.data.Dimension1;
				if (Array.isArray(this.data.Dimension1)) {
					dim1 = Array.prototype.join.call(this.data.Dimension1, ';');
				}
				this.extraPlotLines = (this.data.PlotLines || []).map(function (el) {
					return {
						color: el.Color,
						value: el.Value,
						label: {
							text: el.Label
						}
					}
				});
				self.chartRequest = {
					chartType: this.data.Chart,
					dimension1: dim1,
					dimension2: this.data.Dimension2,
					fact1: this.data.Fact1,
					fact1function: this.data.Fact1Function,
					fact2: this.data.Fact2,
					fact2function: this.data.Fact2Function,
					ishistory: this.data.IsHistory,
					filter: this.data.filter,
					tableName: this.data.TableName,
					drilldown: this.data.Drilldown,
					plotLines: this.extraPlotLines
				};
				if (this.data.isNew) {
					if (this.data.Chart == 'metric') {
						self.chartRequest = {
							filtername: this.data.Dimension1[0],
							fact: this.data.Fact1,
							factfunction: this.data.Fact1Function,
							filtervalue1: this.data.FilterValue1,
							filtervalue2: this.data.FilterValue2,
							goal: this.data.Goal,
							comparisonType: this.data.ComparisonType,
							filter: null,
							tableName: this.data.TableName
						}
						POST('/baas/nominow_dashboard/dashmetricdata', self.chartRequest)
							.then(xhr => {
								//console.log(xhr.responseText);
								const response = JSON.parse(xhr.responseText);
								self.chartData = response;
								self.showNewMetric(response);
							})
							.catch(xhr => {
								console.log('chart load error', xhr);
								self.error = `failed to get chartdata ${xhr.ErrorCode}${xhr.responseText}`;
							});
					}
					else {
						POST('/baas/nominow_dashboard/dashchartdata', self.chartRequest)
							.then(xhr => {
								console.log('chartdata', xhr.responseText);
								const response = JSON.parse(xhr.responseText);
								self.chartData = response;
								let chartType = self.data.Chart;
								if (chartType == 'bars' || chartType == 'multibars') {
									if (response.Dimension2) {
										chartType = 'multibars';
									} else {
										chartType = 'bars';
									}
								}
								if (chartType == 'multilines') {
									chartType = 'lines';
								}
								if (chartType == 'table') {
									chartType = 'heatmap';
								}
								if (self.chartData && self.chartData.Values) {
									self.currentchart = chartType;
								} else {
									self.error = 'no data returned for chart';
								}
							})
							.catch(xhr => {
								console.log('chart load error', xhr);
								self.error = `failed to get chartdata ${xhr.ErrorCode}${xhr.responseText}`;
							});
					}
				}
				else {
					POST('/baas/nominow_dashboard/dashboardchartdata', self.chartRequest)
						.then(xhr => {
							// console.log(xhr.responseText);
							const response = JSON.parse(xhr.responseText);
							self.showChart(response);
						})
						.catch(xhr => {
							console.log('chart load error', xhr);
							self.error = `failed to get chartdata ${xhr.ErrorCode}${xhr.responseText}`;
						});
				}
			}
		},
		methods: {
			chartReady: function (chart) {
				this.chart = {
					chart: chart
				};
				this.$emit('chartReady', this.chart);
			},
			showChart: function (chartData) {
				//console.log('chart', this.data.Chart, JSON.stringify(chartData));
				this.log = chartData;
				// console.log("chartData", chartData);
				if (this.data.Chart == 'donut') {
					this.showDonut(chartData);
				} else if (this.data.Chart == 'multibars') {
					this.showMultiBars(chartData);
				} else if (this.data.Chart == 'bars') {
					this.showBars(chartData);
				} else if (this.data.Chart == 'columns') {
					this.showColumns(chartData);
				} else if (this.data.Chart == 'lines') {
					this.showLines(chartData);
				} else if (this.data.Chart == 'heatmap') {
					this.showHeatmap(chartData);
				} else if (this.data.Chart == 'table') {
					this.showTable(chartData);
				} else {
					window.initToast(`Unknown chart type ${this.data.Chart}`, 'warning');
				}
			},
			showBars: function (chartData) {
				const labels = [];
				const valuedata = [];
				for (let t = 0; t < chartData.Values.length; t++) {
					const value = chartData.Values[t].Fact1;
					const dimension = chartData.Values[t].Dimension1;

					labels.push(dimension);
					valuedata.push({
						y: value
					});
				}
				if (valuedata == null || valuedata.length == 0) {
					window.initToast('No valuedata for chart present, are dimensions correctly mapped?', 'error');
				} else {
					this.chart = {
						id: `chartBars${new Date().getTime()}`,
						data: valuedata,
						categories: labels,
						type: 'bars',
						prefix: null,
						suffix: null,
						xTitle: this.data.Fact2,
						yTitle: this.data.Fact1,
						extraPlotLines: this.extraPlotLines

					};
					this.$emit('chartReady', this.chart);
				}
			},
			showColumns: function (chartData) {
				const labels = [];
				const valuedata = [];
				for (let t = 0; t < chartData.Values.length; t++) {
					const value = chartData.Values[t].Fact1;
					const dimension = chartData.Values[t].Dimension1;

					labels.push(dimension);
					valuedata.push({
						y: value
					});
				}
				if (valuedata == null || valuedata.length == 0) {
					window.initToast('No valuedata for chart present, are dimensions correctly mapped?', 'error');
				} else {
					var title = (chartData.Kpi.find(k => k.KPICode == this.data.Fact1) || { KPIName: this.data.Fact1 }).KPIName;
					this.chart = {
						id: `chartColumns${new Date().getTime()}`,
						data: valuedata,
						categories: labels,
						type: 'columns',
						prefix: null,
						suffix: null,
						xTitle: null,
						yTitle: title,
						extraPlotLines: this.extraPlotLines

					};
					this.$emit('chartReady', this.chart);
				}
			},
			showMultiBars: function (chartData) {
				const groups = [];
				const labels = [];
				const valuedata = [];
				for (let t = 0; t < chartData.Dim2Items.length; t++) {
					const values = [];
					const dimension = chartData.Dim2Items[t].value;
					for (var i = 0; i < chartData.Values.length; i++) {
						if (chartData.Values[i].Dimension2 == dimension) {
							values.push(chartData.Values[i].Fact1);
						}
					}

					labels.push(dimension);
					valuedata.push({
						y: values
					});

				}
				for (var i = 0; i < chartData.Dim1Items.length; i++) {
					groups.push(chartData.Dim1Items[i].TagName);
				}
				if (valuedata == null || valuedata.length == 0) {
					window.initToast('No valuedata for chart present, are dimensions correctly mapped?', 'error');
				} else {
					var title = (chartData.Kpi.find(k => k.KPICode == this.data.Fact1) || { KPIName: this.data.Fact1 }).KPIName;
					this.chart = {
						id: `chartMulti${new Date().getTime()}`,
						data: valuedata,
						categories: labels,
						groups: groups,
						type: 'multibars',
						prefix: null,
						suffix: null,
						xTitle: null,
						yTitle: title,
						extraPlotLines: this.extraPlotLines

					};
					//vuelog(this.chart);
					this.$emit('chartReady', this.chart);
				}
			},
			showLines: function (chartData) {
				const groups = [];
				const labels = [];
				const valuedata = [];
				for (let t = 0; t < chartData.Dim1Items.length; t++) {
					const values = [];
					const dimension = chartData.Dim1Items[t].TagCode;
					const name = chartData.Dim1Items[t].TagName;
					for (var i = 0; i < chartData.Dim2Items.length; i++) {
						const dim2 = chartData.Dim2Items[i].value;
						for (let j = 0; j < chartData.Values.length; j++) {
							if (chartData.Values[j].TagCode == dimension && chartData.Values[j].Dimension2 == dim2) {
								values.push(chartData.Values[j].Fact1);
								break;
							}
						}
					}
					if (values.length > 0) {
						labels.push(name);
						valuedata.push({
							name: name,
							data: values
						});
					}
				}
				for (var i = 0; i < chartData.Dim2Items.length; i++) {
					groups.push(chartData.Dim2Items[i].value);
				}
				if (valuedata == null || valuedata.length == 0) {
					window.initToast('No valuedata for chart present, are dimensions correctly mapped?', 'error');
				} else {
					const obj = {
						id: `chartLines${new Date().getTime()}`,
						data: valuedata,
						categories: labels,
						groups: groups,
						type: 'lines',
						prefix: null,
						suffix: null,
						xTitle: this.data.Fact2,
						yTitle: this.data.Fact1
					};
					this.chart = obj;
					this.$emit('chartReady', this.chart);
				}
			},
			showDonut: function (chartData) {
				const c = {
					name: this.data.Name,
					id: `chart${new Date().getTime()}`,
					data: Array.prototype.map.call(chartData.Values, el => ({
						y: el.Percentage,
						count: window.groupDigits(el.Number)
					})),
					categories: Array.prototype.map.call(chartData.Values, el => el.Dimension1),
					type: 'donut',
					prefix: null,
					suffix: null
				};
				this.chart = c;
				this.$emit('chartReady', this.chart);
			},
			showHeatmap: function (chartData) {
				const _data = chartData.Values;
				const _kpis = chartData.Kpi;

				const obj = {
					id: `chartHeatmap${new Date().getTime()}`,
					data: _data,
					kpis: _kpis,
					d1N: this.data.Dimension1,
					type: 'heatmap',
					xTitle: this.data.Fact2,
					yTitle: this.data.Fact1
				};
				this.chart = obj;
				this.$emit('chartReady', this.chart);
			},
			showTable: function (chartData) {
				const _data = chartData.Values;
				const _kpis = chartData.Kpi;

				const obj = {
					id: `chartTable${new Date().getTime()}`,
					data: _data,
					kpis: _kpis,
					type: 'table',
					xTitle: this.data.Fact2,
					yTitle: this.data.Fact1
				};
				this.chart = obj;
				this.$emit('chartReady', this.chart);
			},
			showNewMetric: function (metricData) {
				this.data.ValuePrefix = this.data.ValuePrefix || '';
				this.data.ValueSuffix = this.data.ValueSuffix || '';
				this.metric = {
					amount1: this.data.ValuePrefix + window.groupDigits(('' + metricData.InitialValue).replace('.', ',')) + this.data.ValueSuffix,
					amount2: this.data.ValuePrefix + window.groupDigits(('' + metricData.CompareValue).replace('.', ',')) + this.data.ValueSuffix,
					amountpct: this.data.ValuePrefix + metricData.Comparison + this.data.ValueSuffix,
					amount1text: this.data.FilterValue1Title,
					amount2text: this.data.FilterValue2Title,
					amountpctclass: parseFloat(metricData.Comparison) < 0 ? 'has-text-danger' : 'has-text-success'
				}
			},
			showCustomChart: function () {
				const self = this;
				let compCode = this.data.Component;
				const compCodeTemplate = this.data.ComponentTemplate;

				compCode = compCode.replace('``', `\`${compCodeTemplate}\``);

				//remove old code
				$('[data-custom]').remove();


				const newCompId = `component-${new Date().getTime()}`;
				const htmltest = `<script id="scriptfor-${newCompId}" data-custom="true">Vue.component("${newCompId}", ${compCode});</script>`;
				$('body').append(htmltest);

				Vue.nextTick(() => {
					self.customcomponent = newCompId;
				});
			}
		}
	});
})();
